import styled from "styled-components";

export const Container = styled.div`
  color: ${({ theme }) => theme.editor.textLight};
  font-family: ${({ theme }) => theme.fontMedium};
  max-width: 40vw;
  min-width: 550px;

  && .ant-alert-error {
    border: 0;
    margin-bottom: 1.5em;
    border-radius: ${({ theme }) => theme.borderRadiusContainers};
  }

  .two-columns {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 20px;
    align-items: start;
  }

  #upload-drag-drop-container {
    position: relative;
    border: 2px dashed ${({ theme }) => theme.editor.backgroundLight};
    border-radius: 8px;
    padding: 1.5em;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 140px;
    transition: all 0.2s ease-in-out;

    .drag-drop-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      z-index: 1;

      p {
        margin: 0;
        font-size: 14px;
        opacity: 0.8;
      }

      .drag-drop-or {
        font-size: 12px;
        opacity: 0.6;
        text-transform: lowercase;
      }
    }
  }

  #drag-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    pointer-events: none;
  }

  #upload-drag-drop-container.drag-active {
    border-color: ${({ theme }) => theme.editor.textLight};
    background-color: ${({ theme }) => theme.editor.backgroundLight}20;
    transform: scale(1.02);
  }

  #original-lanes-container {
    margin-top: 0;
  }

  #original-lanes-header {
    font-family: ${({ theme }) => theme.fontHeavy};
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 0.5em;
  }

  #original-lanes-list-container {
    display: flex;
    flex-wrap: wrap;
  }

  #matching-stems-container {
    margin-top: 0.5em;
    padding-top: 1.5em;
  }

  #matching-stems-header {
    font-family: ${({ theme }) => theme.fontHeavy};
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 0.5em;

    &.collapsible-header {
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      user-select: none;

      &:hover {
        opacity: 0.8;
      }
    }

    .caret-icon {
      transition: transform 0.2s ease-in-out;
      flex-shrink: 0;

      &.expanded {
        transform: rotate(90deg);
      }
    }

    .header-params {
      color: #777;
      font-weight: 400;
    }
  }

  #matching-stems-list-container {
    display: flex;
    flex-direction: column;
    gap: 6px;

    &.scrollable {
      max-height: 265px;
      overflow-x: hidden;
      overflow-y: auto;
      padding-right: 4px;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        background: ${({ theme }) => theme.editor.backgroundLight}40;
        border-radius: 3px;
      }

      &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.editor.backgroundLight};
        border-radius: 3px;
      }
    }
  }

  .loading-text,
  .no-matches-text {
    font-family: ${({ theme }) => theme.fontMedium};
    font-size: 14px;
    opacity: 0.7;
    padding: 0.5em 0;
  }

  .load-more-btn {
    margin-top: 0.5em;
    margin-left: 130px;
    height: 24px;
    padding: 0 12px;
    font-family: ${({ theme }) => theme.fontMedium};
    font-size: 13px;
    color: ${({ theme }) => theme.editor.textLight};
    background-color: ${({ theme }) => theme.backgroundTag || "#2a2a2a"};
    border: none;
    border-radius: 12px;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;

    &:hover {
      background-color: #505050;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;
